import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/blacksmith-ui/cn";
const CELLS = [0, 1, 2].flatMap(row => [0, 1, 2].map(column => ({
  x: 1 + column * 6,
  y: 1 + row * 6
})));

/** Rail glyph for Sandboxes: a 3x3 fleet of VMs, in the pixel style of the Proof icon. */
export function SandboxesIcon(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = CELLS.map(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" aria-hidden={true} className={t1}>{t2}</svg>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(t0) {
  const {
    x,
    y
  } = t0;
  return <rect key={`${x}-${y}`} x={x} y={y} width={4} height={4} rx={1} />;
}